// utils/windowId.ts
export const ValidarRut = (rutCompleto) => {
    rutCompleto = rutCompleto.replace(/\./g, '').replace('-', '');
    const rut = rutCompleto.slice(0, -1);
    let dv = rutCompleto.slice(-1).toUpperCase();

    if (!/^\d+$/.test(rut)) return false;

    let suma = 0, multiplo = 2;
    for (let i = rut.length - 1; i >= 0; i--) {
        suma += parseInt(rut.charAt(i)) * multiplo;
        multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    const dvEsperado = 11 - (suma % 11);
    const dvCalculado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();

    //return dv === dvCalculado
    return dv === dvCalculado? `${rut}-${dv}` :false;
}

export const ValidarEmail = (value) => {
    // Expresión regular básica para validar email
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
};